import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";

import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import {
  getCourseApplicantDetail,
  postCancelCourseApplicant,
} from "../../../../services/apiCourseApplicant";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Completion from "./Completion";
import { useAuth } from "../../../../contexts/AuthContext";
import { AUTH_UNIVERSITY } from "../../../../utils/config";

const CancelCourseApplicant = () => {
  // ユーザー情報
  const { user } = useAuth();
  // 講座ID
  const { id } = useParams();
  // ユーザーID
  const { userId } = useParams();
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  // 初回レンダリング
  useEffect(() => {
    if (user.authority == AUTH_UNIVERSITY) {
      navigate("/admin/404");
    }
    (async function () {
      const data = await getCourseApplicantDetail(id, userId);
      if (data == undefined || !data) return;
      if (Object.keys(data).length === 0) {
        navigate("/admin/404");
      }
      setValue("course_name", data["course_name"]);
      setValue("login_id", data["login_id"]);
      setValue("name", data["name"]);
      setValue("updated_at", data["updated_at"]);
    })();
  }, []);

  // 申込者詳細へ戻る
  const handleBack = (e) => {
    // e.preventDefault();
    navigate(-1);
  };

  // 確認 or 登録
  async function onSubmit(data) {
    // 講座キャンセル
    const json = await postCancelCourseApplicant(id, userId, data);
    if (json) {
      // 完了画面表示
      setIsCompFlg(true);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
  }

  return (
    <>
      {isCompFlg ? (
        <Completion
          subtitle="講座キャンセル完了"
          explanation="講座キャンセルが完了いたしました。"
          link={"/admin/course/detail/" + id + "/" + 1}
          btntext="講座詳細へ戻る"
        ></Completion>
      ) : (
        <div className={styles.main}>
          <ScreenTitle>講座管理</ScreenTitle>
          <SubScreenTitle>講座キャンセル確認</SubScreenTitle>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <table className={styles.input_form_table}>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="講座名"
                  name="course_name"
                  isStatic={true}
                />
              </tr>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="学生番号(8桁)"
                  name="login_id"
                  isStatic={true}
                />
              </tr>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{}}
                  label="氏名"
                  name="name"
                  isStatic={true}
                />
              </tr>
            </table>
            <div className={styles.buttonbox}>
              <Button
                type="button"
                onClick={() => handleBack()}
                styleType="back"
              >
                申込者詳細へ戻る
              </Button>
              <Button type="submit" styleType="new">
                講座をキャンセルする
              </Button>
            </div>
            <div hidden>
              <TextField
                errors={errors}
                register={register}
                validation={{}}
                label=""
                name="updated_at"
                isStatic={true}
              />
            </div>
          </Form>
          <div className={styles.buttonbox}>
            <Link className={styles.link} to="/admin/top">
              トップページへ戻る
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default CancelCourseApplicant;
